import controller from './coupon-code-controller';

export const CouponCodeComponent = {
	templateUrl: 'coupon-code/coupon-code',
	controller,
	bindings: {
		parentPage: '<',
		successCallback: '&'
	}
};
